var SupportLiveStatusAndNotesPresentation;

SupportLiveStatusAndNotesPresentation = {
  editable: {
    status: "Can be edited until <span class='localtime'>{{editable_deadline}}</span>",
    notes: I18n.translate('js.modules.notes.editable_live_notes_message')
  },
  not_editable: {
    redeemed: {
      status: "Event has passed",
      notes: ""
    },
    expired: {
      status: "Event has passed",
      notes: ""
    },
    expired_unredeemed: {
      status: "Event has passed",
      notes: ""
    },
    expired_redeemed: {
      status: "Event has passed",
      notes: ""
    },
    available: {
      status: "Ready to print",
      notes: ""
    }
  }
};

module.exports = SupportLiveStatusAndNotesPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9saXZlX21lc3NhZ2VzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ByZXNlbnRlcnMvbGl2ZV9tZXNzYWdlcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxxQ0FBQSxHQUNDO0VBQUEsUUFBQSxFQUNDO0lBQUEsTUFBQSxFQUFRLDBFQUFSO0lBQ0EsS0FBQSxFQUFPLElBQUksQ0FBQyxTQUFMLENBQWUsOENBQWYsQ0FEUDtHQUREO0VBR0EsWUFBQSxFQUNDO0lBQUEsUUFBQSxFQUNDO01BQUEsTUFBQSxFQUFRLGtCQUFSO01BQ0EsS0FBQSxFQUFPLEVBRFA7S0FERDtJQUdBLE9BQUEsRUFDQztNQUFBLE1BQUEsRUFBUSxrQkFBUjtNQUNBLEtBQUEsRUFBTyxFQURQO0tBSkQ7SUFNQSxrQkFBQSxFQUNDO01BQUEsTUFBQSxFQUFRLGtCQUFSO01BQ0EsS0FBQSxFQUFPLEVBRFA7S0FQRDtJQVNBLGdCQUFBLEVBQ0M7TUFBQSxNQUFBLEVBQVEsa0JBQVI7TUFDQSxLQUFBLEVBQU8sRUFEUDtLQVZEO0lBWUEsU0FBQSxFQUNDO01BQUEsTUFBQSxFQUFRLGdCQUFSO01BQ0EsS0FBQSxFQUFPLEVBRFA7S0FiRDtHQUpEOzs7QUFvQkQsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
